<!-- apps/frontend/src/components/flow/nodes/ToolInputNode.vue -->
<template>
  <div
    :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
             selected ? 'border-violet-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <!-- Header -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-violet-400">input</span>
        <strong class="text-white">{{ $t('flowEditor.palette.toolInput') }}</strong>
      </div>
      <ValidationMarker :error="data.__validationError" />
    </div>

    <!-- Body -->
    <div class="p-3">
      <p class="text-gray-400 text-xs mb-1">{{ $t('flowEditor.nodes.toolInputNode.toolNameLabel') }}</p>
      <p class="text-white text-sm font-mono truncate">
        {{ data.toolName || $t('flowEditor.nodes.toolInputNode.emptyToolName') }}
      </p>
      <p class="text-gray-400 text-xs mt-1">{{ $t('flowEditor.nodes.common.parameterCount', (data.parameters || []).length) }}</p>
    </div>

    <Handle type="source" :position="Position.Right" />

    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" accent="violet" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
